import React from 'react';
import { HelpCenterSettingsRedirect } from '@atlassian/jira-servicedesk-customer-service-common/src/ui/help-center-settings-redirect/HelpCenterSettingsRedirectOld.tsx';
import type ProjectSettingsServiceDeskTicketTypesConfig from '@atlassian/jira-spa-apps-project-settings-service-desk-ticket-types-config/src/ui/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskTicketTypesConfig = lazyForPaint<
	typeof ProjectSettingsServiceDeskTicketTypesConfig
>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-service-desk-ticket-types-config", jiraSpaEntry: "async-project-settings-service-desk-ticket-types-config" */ '@atlassian/jira-spa-apps-project-settings-service-desk-ticket-types-config'
		),
);

const AsyncProjectSettingsServiceDeskTicketTypesConfig = (): React.JSX.Element => (
	<HelpCenterSettingsRedirect page="ticket-types-config">
		<LazyPage
			Page={LazyProjectSettingsServiceDeskTicketTypesConfig}
			pageId="project-settings-ticket-types-config"
			shouldShowSpinner
		/>
	</HelpCenterSettingsRedirect>
);

export default AsyncProjectSettingsServiceDeskTicketTypesConfig;
